<template>
    <div class="grid">
      <div class="grid-body" id="booking-transaction-detail">
        <loading :active.sync="isLoading" :is-full-page="false"></loading>
        <div>
          <div class="card-item">
            <div class="card-item-header">
              <label
                slot="header"
                class="card-item-title"
              >{{$t("_BOOKING_TRANSACTION_DETAIL.DETAIL")}}</label>
            </div>
            <div class="card-item-content">
              <v-row>
                <v-col>
                  <span class="d-block">
                    <strong>{{data.ota.otaI18n.find(x=>x.lang == defaultI18n).name}}</strong>
                  </span>
                  <span class="d-block">
                    {{$t('_BOOKING_TRANSACTION_DETAIL.BOOKING_CODE')}}
                    <strong>{{data.bookingCode}}</strong>
                  </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <label
                    class="label-input"
                  >{{ $t("_BOOKING_TRANSACTION_DETAIL.PAYMENT_METHOD") + $t("REQUIRED") }}</label>
                  <select-text
                    :items="listPaymentMethod"
                    :id.sync="data.paymentType"
                    :error="error.paymentType.error"
                    @change="changePaymentMethod"
                  />
                </v-col>
                <v-col cols="6" v-if="showInputTransactionCode">
                  <label
                    class="label-input"
                  >{{ $t("_BOOKING_TRANSACTION_DETAIL.TRANSACTION_CODE") + $t("REQUIRED") }}</label>
                  <input-text :model.sync="data.transCode" :error.sync="error.transCode.error" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <label
                    class="label-input"
                  >{{ $t("_BOOKING_TRANSACTION_DETAIL.TRANSACTION_DATE")}} ({{$t("TIME_ZONE_HOTEL")}}) {{$t("REQUIRED") }}</label>
                  <div class="date-picker-wrapper w-100">
                    <datetime
                        type="datetime"
                        v-model="data.transDate"
                        :phrases="{ok: $t('_REGISTER.NEXT'), cancel: $t('_LOGIN.CANCEL')}"
                        :hour-step="1"
                        :minute-step="1"
                        :max-datetime="maxDatetime"
                        :week-start="7"
                        :error.sync="error.transDate.error"
                        format="dd/MM/yyyy HH:mm:ss"
                        auto
                        ></datetime>
                    <!-- <date-picker :model.sync="data.transDate" :max="_moment(currentDate).format('YYYY-MM-DD')" :error.sync="error.transDate.error" /> -->
                  </div>
                </v-col>
                <v-col cols="6">
                  <label
                    class="label-input"
                  >{{ $t("_BOOKING_TRANSACTION_DETAIL.AMOUNT") + " (" + data.currencyCode + ")" + $t("REQUIRED") }}</label>
                  <vuetify-number :options="data.currencyCode == 'VND' ? priceOptionsVi : priceOptionsEn"
                  :rules="ruleNotEmpty"
                  dense outlined v-model="data.unpaid"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <label class="label-input">{{ $t("_BOOKING_TRANSACTION_DETAIL.NOTE") }}</label>
                  <input-textarea :rows="4" :model.sync="data.notes" :error.sync="error.notes.error" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn outlined v-if="!item" @click="back" class="mr-3 main-btn btn-secondary">{{ $t("BACK") }}</v-btn>
                  <v-btn color="primary" v-else @click="() => { $emit('close') }" class="mr-3 main-btn btn-pmirary">{{ $t("CLOSE") }}</v-btn>
                  <v-btn color="primary"
                    @click="validateTransactionDetail"
                    class="main-btn btn-pmirary"
                  >{{ $t("SAVE") }}</v-btn>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<style lang="scss" scoped>
.col-12 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}
.vdatetime-input{
  width: 100%;
  height: 40px;
}
</style>

<script>
import PageHeader from "@/components/Utils/Header.vue";
import LeftMenu from "@/components/Utils/LeftMenu.vue";
import Input from "@/components/Utils/Input.vue";
import Select from "@/components/Utils/Select.vue";
import DatePicker from "@/components/Utils/DatePicker.vue";
import Textarea from "@/components/Utils/Textarea.vue";
import { getBkTdError } from "@/_helpers/config.js";
import { REGEX_NUMBER, REGEX_MONEY_SIMPLE } from "@/_helpers/constant.js";
import { _validateFormI18n, _alert } from "@/_helpers/function.js";
import { service } from "@/_services/Booking/booking.service.js";
import moment, { max } from "moment";
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { Settings, DateTime as LuxonDateTime } from 'luxon';

export default {
  props: {
    item: {
      type: Object,
      default: null
    },
  },
  components: {
    "page-header": PageHeader,
    "left-menu": LeftMenu,
    "input-text": Input,
    "select-text": Select,
    "date-picker": DatePicker,
    "input-textarea": Textarea,
    "datetime": Datetime
  },
  data() {
    return {
      ruleNotEmpty: [v => !!v || this.$t("NOT_EMPTY")],
      isLoading: false,
      sysLang: this.$i18n.locale,
      data: null,
      error: getBkTdError(),
      showInputTransactionCode: false,
      selectedPaymentMethodId: null,
      listPaymentMethod: [
        {
          id: 1,
          key: "BANK_TRANSFER",
          value: this.$t("_BOOKING_TRANSACTION_DETAIL.BANK_TRANSFER")
        },
        {
          id: 2,
          key: "CASH",
          value: this.$t("_BOOKING_TRANSACTION_DETAIL.CASH")
        },
        {
          id: 3,
          key: "DEBT",
          value: this.$t("_BOOKING_TRANSACTION_DETAIL.DEBT")
        },
        {
          id: 4,
          key: "CARD",
          value: this.$t("_PAYGATE.PAYMENT_CARD")
        }
      ],
       currentDate: moment()
        .startOf("day")
        .toDate(),
        maxDatetime: LuxonDateTime.local().plus({ days: 0 }).toISO(),
    };
  },
  computed: {
    REGEX_NUMBER() {
      return REGEX_NUMBER;
    },
    REGEX_MONEY_SIMPLE() {
      return REGEX_MONEY_SIMPLE;
    }
  },
  created() {
    Settings.defaultLocale = this.$i18n.locale;
    // DateTime.local().setLocale(this.$i18n.locale).locale;
    this.initialize();
  },
  methods: {
    // Run when start
    initialize() {
      const item = sessionStorage.getItem('item');
      if (this.item == null && !item) {
        this.back();
      }
      this.data = this.item || JSON.parse(item);
      this.data.unpaid = this.getAmountUnpaid();
    },
    // Go back
    back() {
      this.$router.back();
    },
    // Change payment method
    changePaymentMethod() {
      this.showInputTransactionCode = this.data.paymentType === 1;
    },
    // Validate transaction detail, then save it
    validateTransactionDetail() {
      let { isValid, error } = _validateFormI18n(this.data, this.error);
      this.error = error;
      if (!isValid) return false;
      if (this.data.paymentType === 1 && !this.data.transCode) {
        this.error.transCode.error = true;
        this.$store.commit("alert/display", {
          message: this.$t("_VALIDATE.REQUIRED"),
          error: true,
          success: false
        });
        isValid = false;
        return;
      }
      this.confirmTransactionDetail();
    },
    // Confirm transaction detail
    confirmTransactionDetail() {
      let temp = {
        code: this.data.bookingCode,
        paymentType: this.data.paymentType,
        transCode: this.data.transCode,
        transDate: this.data.transDate,
        amount: this.data.unpaid,
        notes: this.data.notes
      };
      this.isLoading = true;
      service
        .updateTransaction(temp)
        .then(res => {
          if (res.responseCode === 0) {
            if(this.item) {
              this.$emit('reload');
            } else {
              this.back();
            }
          }
          _alert(res, this.$t(res.data), false);
        })
        .finally(() => (this.isLoading = false));
    },
    getAmountUnpaid() {
      // return this.data.pays
      //   .filter(x => x.status != 0)
      //   .reduce((acc, cur) => cur.amount + acc, 0);
      if (this.data.bookingPayments.find(x => x.paymentStatus != 0))
        return this.data.bookingPayments.find(x => x.paymentStatus != 0).amount;
      else return 0;
    },
    _moment: moment
  },
  destroyed() {
    sessionStorage.removeItem('item');
  },
};
</script>